import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment-dots",
  "use": "icon-comment-dots-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-comment-dots\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM320 576a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z m192 0a64 64 0 1 0 0-128 64 64 0 0 0 0 128z\" fill=\"#d0d4d7\" p-id=\"4928\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment-dots.svg
// module id = ILAv
// module chunks = 102